import LegalSection from "@/pages/legal/components/LegalSection";

export default function PrivacyPage() {
  return (
    <>
      <h1 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
        Política de Privacidad
      </h1>
      <p className="mt-2 text-sm text-foreground-500">
        Última actualización: 10 de septiembre de 2026
      </p>
      <p className="mt-4 text-sm leading-7 text-foreground-700 md:text-[15px] md:leading-8">
        En VendeYa nos tomamos muy en serio la protección de tus datos
        personales. Esta política describe qué información recopilamos, cómo la
        utilizamos y las medidas que adoptamos para mantenerla segura.
      </p>

      <div className="mt-8">
        <LegalSection title="1. Responsable del tratamiento">
          <p>
            El responsable del tratamiento de los datos personales recopilados a
            través de la plataforma es el equipo de VendeYa. Para cualquier
            consulta relativa a esta política puedes contactarnos a través de los
            canales indicados en el sitio.
          </p>
        </LegalSection>

        <LegalSection title="2. Datos que recopilamos">
          <p>Recopilamos las siguientes categorías de información:</p>
          <ul className="list-disc space-y-2 pl-5">
            <li>
              <strong>Datos de cuenta:</strong> nombre, correo electrónico y
              credenciales de acceso que proporcionas al registrarte.
            </li>
            <li>
              <strong>Contenido publicado:</strong> anuncios, descripciones,
              imágenes y mensajes que compartes en la plataforma.
            </li>
            <li>
              <strong>Datos de uso:</strong> páginas visitadas, interacciones y
              preferencias de navegación.
            </li>
            <li>
              <strong>Datos técnicos:</strong> dirección IP, tipo de dispositivo
              y navegador.
            </li>
          </ul>
        </LegalSection>

        <LegalSection title="3. Uso de la información">
          <p>Utilizamos tus datos para:</p>
          <ul className="list-disc space-y-2 pl-5">
            <li>Crear y gestionar tu cuenta, y permitir el acceso al servicio.</li>
            <li>Publicar y mostrar tus anuncios a otros usuarios.</li>
            <li>Mejorar la experiencia de uso y el funcionamiento de la plataforma.</li>
            <li>Cumplir con obligaciones legales y garantizar la seguridad del servicio.</li>
          </ul>
        </LegalSection>

        <LegalSection title="4. Seguridad de los datos">
          <p>
            Tus datos se almacenan de forma segura en una infraestructura de
            backend gestionada (Readdy Backend), que aplica cifrado en tránsito y
            controles de acceso para proteger la información frente a accesos no
            autorizados, pérdida o alteración.
          </p>
          <p>
            Aplicamos políticas de acceso basadas en permisos para que cada
            usuario únicamente pueda consultar y modificar la información que le
            corresponde, y revisamos periódicamente nuestras medidas de seguridad.
          </p>
        </LegalSection>

        <LegalSection title="5. Compartir datos con terceros">
          <p>
            No vendemos tus datos personales. Únicamente compartimos información
            cuando es estrictamente necesario para prestar el servicio, cumplir
            con una obligación legal, o con tu consentimiento expreso. Los
            proveedores que nos asisten en el funcionamiento técnico están sujetos
            a obligaciones de confidencialidad.
          </p>
        </LegalSection>

        <LegalSection title="6. Tus derechos">
          <p>
            Puedes acceder, rectificar, eliminar o limitar el tratamiento de tus
            datos personales, así como solicitar su portabilidad, en los términos
            previstos por la normativa aplicable. Para ejercer estos derechos,
            contacta con nosotros y atenderemos tu solicitud en un plazo razonable.
          </p>
        </LegalSection>

        <LegalSection title="7. Retención de datos">
          <p>
            Conservamos tus datos personales mientras tu cuenta permanezca activa
            y durante el tiempo adicional necesario para cumplir con obligaciones
            legales, resolver disputas o hacer cumplir nuestros acuerdos.
            Transcurrido dicho plazo, los datos se eliminan o anonimizan de forma
            segura.
          </p>
        </LegalSection>
      </div>
    </>
  );
}